import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['type', 'index']);
  const modifyLocation = `modifyLocation(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyLocation} {
      id
    }
  }
`;
};
